"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "campli": {
    "0807e367": [{
      "hkey": "a3d077c6",
      "slug": "garrufo-guazzano",
      "name": "Garrufo-Guazzano",
      "primary": true,
      "skipSearch": false
    }],
    "garrufo": [{
      "hkey": "a3d077c6",
      "slug": "garrufo-guazzano",
      "name": "Garrufo-Guazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3773cc17": [{
      "hkey": "a3d077c6",
      "slug": "garrufo-guazzano",
      "name": "Garrufo-Guazzano",
      "primary": true,
      "skipSearch": false
    }],
    "guazzano": [{
      "hkey": "a3d077c6",
      "slug": "garrufo-guazzano",
      "name": "Garrufo-Guazzano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "campli"
    }],
    "79cdc4da": [{
      "hkey": "12a102c4",
      "slug": "molviano-la-madonna-cognoli",
      "name": "Molviano-La Madonna-Cognoli",
      "primary": true,
      "skipSearch": false
    }],
    "molviano": [{
      "hkey": "12a102c4",
      "slug": "molviano-la-madonna-cognoli",
      "name": "Molviano-La Madonna-Cognoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "79aead61": [{
      "hkey": "fdd4e279",
      "slug": "la-traversa-nocella",
      "name": "La Traversa-Nocella",
      "primary": true,
      "skipSearch": false
    }],
    "nocella": [{
      "hkey": "fdd4e279",
      "slug": "la-traversa-nocella",
      "name": "La Traversa-Nocella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;